import React, { useEffect, useRef, useState } from 'react'
import { graphql } from "gatsby";

// resources
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

// import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from "swiper";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// components
import { ImageSlide, VideoSlide } from "./heroCarouselSlides";
import { AnchorLink } from "../../components/AnchorLink";
import GitHubVideoModal from '../../components/GitHubVideoModal';
import YouTubeModal from "../../components/YouTubeModal";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import {setViewContent} from '../../assets/js/data-layer';
import {getFullURL} from '../../assets/js/functions';



export const Hero = ({ slice, context }) => {
  // console.log(slice, context)
  const [swiper, setSwiper] = useState(null);
  const carouselSlides = slice.items


  const sectionId = slice.primary.section_id?.text || slice.id
  const anchorLink = slice.primary.anchor_link?.text || ''
  const [show, setShow] = useState(false)
  const [modalDetails, setModalDetails] = useState({})
  const [isYouTubeVideo, setIsYouTubeVideo] = useState({})

  const handleMouseEnter = () => {
    swiper.autoplay.stop();
  };

  const handleMouseLeave = () => {
    swiper.autoplay.start();
  };


  const navigation = {
    nextEl: '.hero-section__carousel-arrow--next',
    prevEl: '.hero-section__carousel-arrow--prev'
  }
  const onCloseBtnClick=() => {
    setShow(false)
    setModalDetails('')
    setIsYouTubeVideo(false)
  }

  const bannerContainerRef = useRef(null);
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const viewContentDataLayer = () => {
    const swiperCore=swiper
    const { realIndex } = swiperCore;
    const slide = carouselSlides[realIndex];
    const contentLink=getFullURL(slide?.cta_link?.url)
    const data={
      contentName:slide.cta_button_text?.text || '',
      contentName:(slide.banner?.alt ? slide.banner?.alt : contentLink) || '',
      contentType:'banner'
    }
    setViewContent(data)
  };
    useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // Callback function fired when intersection changes
        entries.forEach((entry) => {
          setIsBannerVisible(entry.isIntersecting) // Update state based on intersection
        });
      },
      {
        // Optional: Intersection Observer options
        root: null, // default is the viewport
        rootMargin: '0px', // no margin around the root
        threshold: 0.4, // callback fires when 50% of the target is visible
      }
    );

    // Observe the target element if the ref exists
    if (bannerContainerRef.current) {
      observer.observe(bannerContainerRef.current);
    }

    // Cleanup function: disconnect the observer when the component unmounts
    return () => {
      if (bannerContainerRef.current) {
        observer.unobserve(bannerContainerRef.current);
      }
      observer.disconnect();
    };
  }, []); // Empty dependency array ensures the effect runs once on mount
  useEffect(()=>{
    if(isBannerVisible){
      viewContentDataLayer()
    }
  },[isBannerVisible])
  const handleSlideChange = (swiperCore) => {
    // Crucial check: ONLY fire data layer event if the banner is currently visible
    if (!isBannerVisible) {
      //console.log('Swiper Slide Change: Banner not visible, skipping data layer event.');
      return;
    }

    const { realIndex } = swiperCore;
    const slide = carouselSlides[realIndex];

    if(slide) {
      const contentLink=getFullURL(slide?.cta_link?.url)
      const data={
        contentName: slide.cta_button_text?.text||'',
        contentName: (slide.banner?.alt? slide.banner?.alt:contentLink)||'',
        contentType: 'banner'
      }
      setViewContent(data)
      //console.log(`Swiper Slide Change (VISIBLE): Slide Index`,realIndex);
    }
  };

  return (
      <section onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} id={`hero-${sectionId}`}>
        { anchorLink && <AnchorLink link={anchorLink}/> }
        { show && modalDetails?.url && (isYouTubeVideo ?
         <YouTubeModal modalDetails={modalDetails?.url} closeModal={onCloseBtnClick} title={modalDetails?.title}/> :
         <GitHubVideoModal modalDetails={modalDetails?.url} closeModal={onCloseBtnClick} title={modalDetails?.title}/>
        )}
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            ref={bannerContainerRef}
            navigation={navigation}
            pagination={{ clickable: true }}
            initialSlide={0}
            speed={500}
            slidesPerView={1}
            autoplay={{
              delay: 4000,
              disableOnInteraction: true
            }}
            loop={true}
            onSwiper={setSwiper}
            onRealIndexChange={handleSlideChange}
            className='hero-carousel'
        >
          {
            carouselSlides.map((item, index) => {

              return (
                  <SwiperSlide key={`${item.slide_type}-${index}`} className='position-relative'>
                    {!item.content_type_video_modal && !item.content_type &&  <VideoSlide item={item} context={context}/> }
                    {(item.content_type_video_modal || item.content_type) && <ImageSlide item={item} setShow={setShow} setModalDetails={setModalDetails} setIsYouTubeVideo={setIsYouTubeVideo}/> }
                  </SwiperSlide>
              )
            })
          }
          <button className="hero-section__carousel-arrow hero-section__carousel-arrow--prev">
            <span className="visually-hidden">Prev</span>
            <FontAwesomeIcon icon={faChevronLeft} className="fa-solid hero-carousel-icon" size="2xl" />
          </button>
          <button className="hero-section__carousel-arrow hero-section__carousel-arrow--next">
            <span className="visually-hidden">Next</span>
            <FontAwesomeIcon icon={faChevronRight} className="fa-solid hero-carousel-icon" size="2xl" />
          </button>
        </Swiper>
      </section>
  )
}

export const fragment = graphql`
  fragment PageDataBodyHero on PrismicGenericPageDataBodyHero  {
    id
    primary{
      section_id{
        text
      }
      anchor_link{
        text
      }
    }

    items {
      banner {
        thumbnails {
          mobile {
            alt
            url
          }
        }
        url(imgixParams: {q: 100, dpi: 300, dpr: 2, auto: "enhance"})
        alt
      }
      cta_link {
        url
      }
      show_transition
       transitionimage {
              alt
              url
              dimensions {
                height
                width
              }
              thumbnails {
                Transition_image_mobile {
                  alt
                  url
                }
              }
            }
      github_video_filename_mobile
      github_video_filename_desktop
      youtube_video
      youtube_link
      content_type
      content_type_video_modal
      video_title
      label_color
      label_text {
        text
        richText
      }
      reverse_content
      show_button
      show_title
      show_subtitle
      show_paragraph
      cta_button_bg_color
      cta_button_bg_color_hover
      cta_button_border_color
      cta_button_border_radius
      cta_button_border_color_hover
      cta_button_text {
        text
        richText
      }
      cta_button_text_color
      cta_button_text_color_hover
      cta_button_bg_color_transparency
      cta_button_bg_color_hover_transparency
      cta_button_open_in_new_tab
      cta_download_button
      cta_download_button_file {
        url
      }
      cta_download_file_name
      title {
        text
        richText
      }
      title_text_color
      title_font_size_desktop
      title_font_size_mobile
      subtitle {
        text
        richText
      }
      subtitle_text_color
      subtitle_font_size_desktop
      subtitle_font_size_mobile
      paragraph {
        text
        richText
      }
      text_alignment_desktop
      text_alignment_mobile
      paragraph_text_color
      paragraph_font_size_desktop
      paragraph_font_size_mobile
    }
  }
`;




